export const FETCH_SUBCATEGORYLIST_REQUEST = "FETCH_SUBCATEGORYLIST_REQUEST";
export const FETCH_SUBCATEGORYLIST_SUCCESS = "FETCH_SUBCATEGORYLIST_SUCCESS";
export const FETCH_SUBCATEGORYLIST_FAILURE = "FETCH_SUBCATEGORYLIST_FAILURE";
